// "use client";

// import { useEffect, useRef, useState } from "react";
// import Image from "next/image";

// export default function SubscribeEmailModal() {
//   const [email, setEmail] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // ✅ Show modal automatically
//   // useEffect(() => {
//   //     import("bootstrap").then((bootstrap) => {
//   //         const el = document.getElementById("newsletterModal");
//   //         if (el) {
//   //             const modal = new bootstrap.Modal(el);
//   //             modal.show();
//   //         }
//   //     });
//   // }, []);

//   useEffect(() => {
//     let modal: any;
//     const el = document.getElementById("newsletterModal");

//     if (!el) return;

//     const handleHidden = () => {
//       document.body.classList.remove("modal-open");
//       document.body.style.removeProperty("padding-right");
//       document.body.style.removeProperty("overflow"); // ⭐ FIX

//       document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
//     };
//   }, []);

//     import("bootstrap").then((bootstrap) => {
//       modal = new bootstrap.Modal(el);
//       modal.show();

//       el.addEventListener("hidden.bs.modal", handleHidden);
//     });

//     return () => {
//       el.removeEventListener("hidden.bs.modal", handleHidden);
//       if (modal) modal.dispose();
//     };
//   }, []);

//   const handleSubmit = async () => {
//     setError("");
//     setSuccess(false);

//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!email.trim()) return setError("Enter Email!");
//     if (!emailRegex.test(email)) return setError("Enter valid email!");

//     setLoading(true);

//     try {
//       const res = await fetch("/api/subscribe", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ name: "Modal User", email }),
//       });

//       if (res.ok) {
//         setSuccess(true);
//         setEmail("");
//       } else {
//         setError("Subscription failed!");
//       }
//     } catch {
//       setError("Server error!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="modal fade" id="newsletterModal" tabIndex={-1}>
//       <div className="modal-dialog modal-lg modal-dialog-centered">
//         <div className="modal-content rounded-4 overflow-hidden">
//           {/* CLOSE BUTTON */}
//           <button
//             type="button"
//             className="btn-close position-absolute top-0 end-0 m-3"
//             data-bs-dismiss="modal"
//             aria-label="Close"
//             style={{
//               filter: "invert(1)", // ✅ This makes the X white on dark bg
//               opacity: 1,
//               zIndex: 1051, // ensure it’s above modal content
//             }}
//           ></button>

//           <div className="row">
//             {/* LEFT IMAGE */}
//             <div className="col-md-5 g-0 d-none d-md-block">
//               <Image
//                 src="/logo-light.png"
//                 alt="Crypto News"
//                 width={500}
//                 height={500}
//                 className="w-100 h-100 object-fit-cover"
//                 style={{ backgroundColor: "#f79413" }}
//               />
//             </div>

//             {/* RIGHT SIDE */}
//             <div className="col-md-7 p-4 bg-dark text-white ">
//               <h2 className="fw-bold mt-md-4 text-center mb-md-3">
//                 Enhance Your Crypto Space Journey
//               </h2>

//               <p className="fs-6 text-center small mb-md-3  text-white">
//                 Get the latest news, learn from experts, discover new tools and
//                 find inspiration in your inbox.
//               </p>

//               {success ? (
//                 <p className="text-success fw-semibold text-center fs-6">
//                   ✅ Check your inbox to confirm subscription.
//                 </p>
//               ) : (
//                 <>
//                   <div className="input-group my-md-4">
//                     <input
//                       type="email"
//                       className="form-control px-3 py-2"
//                       placeholder="Enter your email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                     <button
//                       className="btn text-white px-4 py-2"
//                       onClick={handleSubmit}
//                       disabled={loading}
//                       style={{ backgroundColor: "#f79413" }}
//                     >
//                       {loading ? "Signing..." : "Sign Up"}
//                     </button>
//                   </div>

//                   {error && <small className="text-danger fs-6">{error}</small>}
//                 </>
//               )}

//               <p className="text-center fs-6 text-white small mt-2 mb-0">
//                 No spam. Unsubscribe any time.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

"use client";

import { useEffect, useState } from "react";
import Image from "next/image";

export default function SubscribeEmailModal() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let modal: any;

    const el = document.getElementById("newsletterModal");
    if (!el) return;

    const handleHidden = () => {
      // Remove modal-specific styles on close
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("padding-right");
      document.body.style.removeProperty("overflow");
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    };

    // Dynamically import Bootstrap JS
    import("bootstrap").then((bootstrap) => {
      modal = new bootstrap.Modal(el);
      modal.show();
      el.addEventListener("hidden.bs.modal", handleHidden);
    });

    // Cleanup on unmount
    return () => {
      if (el) el.removeEventListener("hidden.bs.modal", handleHidden);
      if (modal) modal.dispose();
    };
  }, []);

  const handleSubmit = async () => {
    setError("");
    setSuccess(false);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email.trim()) return setError("Enter Email!");
    if (!emailRegex.test(email)) return setError("Enter valid email!");

    setLoading(true);

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: "Modal User", email }),
      });

      if (res.ok) {
        setSuccess(true);
        setEmail("");
      } else {
        setError("Subscription failed!");
      }
    } catch {
      setError("Server error!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="newsletterModal" tabIndex={-1}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-4 overflow-hidden">
          {/* CLOSE BUTTON */}
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-3"
            data-bs-dismiss="modal"
            aria-label="Close"
            style={{
              filter: "invert(1)",
              opacity: 1,
              zIndex: 1051,
            }}
          ></button>

          <div className="row">
            {/* LEFT IMAGE */}
            <div className="col-md-5 g-0 d-none d-md-block">
              <Image
                src="/logo-light.png"
                alt="Crypto News"
                width={500}
                height={500}
                className="w-100 h-100 object-fit-cover"
                style={{ backgroundColor: "#f79413" }}
                priority
                fetchPriority="high"
              />
            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-7 p-4 bg-dark text-white">
              <h2 className="fw-bold mt-md-4 text-center mb-md-3">
                Enhance Your Crypto Space Journey
              </h2>

              <p className="fs-6 text-center small mb-md-3 text-white">
                Get the latest news, learn from experts, discover new tools and
                find inspiration in your inbox.
              </p>

              {success ? (
                <p className="text-success fw-semibold text-center fs-6">
                  ✅ Check your inbox to confirm subscription.
                </p>
              ) : (
                <>
                  <div className="input-group my-md-4">
                    <input
                      type="email"
                      className="form-control px-3 py-2"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button
                      className="btn text-white px-4 py-2"
                      onClick={handleSubmit}
                      disabled={loading}
                      style={{ backgroundColor: "#f79413" }}
                    >
                      {loading ? "Signing..." : "Sign Up"}
                    </button>
                  </div>

                  {error && <small className="text-danger fs-6">{error}</small>}
                </>
              )}

              <p className="text-center fs-6 text-white small mt-2 mb-0">
                No spam. Unsubscribe any time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
